export default "__VITE_ASSET__CAKVA13I__"